import React from "react";
import { CustomIconButton } from "../../../../buttons";
import { icon, IconComponent } from "../../../../icon-component";
import GenericDialogHeader from "../../../../dialog/generic-dialog-header/GenericDialogHeader";
import { CustomTooltip } from "../../../../tooltip";
import styles from "./AiAgentConfigDialogTitle.module.css";

const AiAgentConfigDialogTitle = ({ helperText = "", onClose, title = "" }) => (
	<GenericDialogHeader className={styles.header}>
		<CustomIconButton icon={icon.faTimes} size="sm" onClick={onClose} />
		<span>{title}</span>
		{helperText && (
			<CustomTooltip title={helperText}>
				<IconComponent className={styles.helperIcon} color="var(--grey-500)" icon={icon.faInfoCircle} />
			</CustomTooltip>
		)}
	</GenericDialogHeader>
);

export default AiAgentConfigDialogTitle;
